let indexPath = 0;

const nextPaths = (acc, coords) => {
  if (typeof coords[0] === 'number') {
    return {
      ...acc,
      [indexPath]: [
        ...(acc[indexPath] || []),
        { lng: coords[0], lat: coords[1] }
      ]
    };
  }
  indexPath += 1;
  return coords.reduce(nextPaths, acc);
};

export default shapesZones =>
  shapesZones.reduce(
    (acc, { geoJson }) => [
      ...acc,
      ...JSON.parse(geoJson).features.reduce(
        (acc2, { geometry: { coordinates } }) => [
          ...acc2,
          ...Object.values(coordinates.reduce(nextPaths, {}))
        ],
        []
      )
    ],
    []
  );
